
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meet/60min",
      function () {
        return require("private-next-pages/meet/60min/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meet/60min"])
      });
    }
  